<!--
component: BrowseSpRoad
author: Ken Nakamura
description: 位置指定道路図閲覧画面
-->
<template>
  <section class="browse-sp-road">
    <v-container fluid >
      <v-row>
      <div class="split">
        <div class="split left-box" >
          <v-container fluid>
            <v-row>
              <ZoomCanvas id="zoom-area" width="300" heigth="200"
                style="margin:5px;"
                :sourceImage="image" :zoom="zoomScale"
                :centerx="zoomCenterX" :centery="zoomCenterY"
                v-if="useCanvas"
              />
              <ZoomImageViewer id="zoom-area" width="300" height="200"
                :imageUrl="imageUrl" :sourceWidth="imageWidth" :sourceHeight="imageHeight"
                :zoom="zoomScale" :targetViewId="targetViewId"
                :centerx="zoomCenterX" :centery="zoomCenterY"
                v-else
              />
            </v-row>
            <v-row>
              <v-col v-for="(page, index) in pages" :key="index"
                cols="12" style="margin:0; padding:0;">
                <v-btn
                  @click="showPage(index)"
                  large width="95%"
                  class="lighten-3 text-h6 ml-1 my-2 blue"
                  :class="{yellow: pageNo==index}" >
                  {{ page.title }}
                </v-btn>
              </v-col>
            </v-row>
            <v-row dense class="mt-3 mb-0">
              <v-col cols=6>
              <v-btn @click="zoomIn()"
                light x-large
                class="text-h5 mx-1 my-3">
                <v-icon color="#55aaff" class="ma-auto">mdi-plus-circle</v-icon>
                拡大
              </v-btn>
              </v-col>
              <v-col>
              <v-btn @click="zoomOut()"
                light x-large
                class="text-h5 mx-1 my-3">
                <v-icon color="#ccaa55" class="ma-auto">mdi-minus-circle</v-icon>
                縮小
              </v-btn>
              </v-col>
            </v-row>
            <v-row dense class="mt-0">
              <v-col cols=12>
              <v-btn @click="printShitei()"
                dark color="#bb7777" x-large width="90%"
                class="text-h5 mx-2 mt-2 mb-1">
                <v-icon color="#dddddd" class="mx-1">mdi-printer</v-icon>
                印刷
              </v-btn>
              </v-col>
              <v-col cols=12 v-show="splitPrintEnable">
              <v-btn @click="printSplit()"
                dark color="#77aabb" x-large width="90%"
                class="text-h5 mx-2 my-1">
                <v-icon color="#dddddd" class="mx-1">mdi-grid</v-icon>
                分割印刷
              </v-btn>
              </v-col>
              <v-col cols=12>
              <v-btn @click="printFrame()"
                dark color="#bbaa77" x-large width="90%"
                class="text-h5 mx-2 my-1">
                <v-icon color="#dddddd" class="mx-1">mdi-printer-3d</v-icon>
                選択印刷
              </v-btn>
              </v-col>
              <v-col cols=12>
              <v-btn @click="toggleFrameVisible()"
                dark color="#55aa77" x-large width="90%"
                class="text-h5 mx-2 my-1">
                <v-icon color="#dddddd" class="mx-1">mdi-select</v-icon>
                A3印刷枠
              </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </div>
        <div class="split right-box">
          <ImageCanvas id="image-viewer"
            width="100%" height="100%"
            :minScale="minScale"
            :imageUrl="imageUrl"
            :imageScale="imageScale"
            :frameVisible="frameVisible"
            :framePos="frameInfo"
            :splitVisible="splitVisible"
            :mouseClick="onImageClick"
            @loaded="imageLoaded"
            @scaleChanged="imageScaleChanged"
            @imgMoved="imageMoved"
            @frameMoved="frameMoved"
            @splitUpdated="splitUpdated"
            v-if="useCanvas"
          />
          <ImageViewer id="image-viewer" :imageUrl="imageUrl"
            :scaleSize="scaleSizeReset"
            :mouseClick="onImageClick"
            @updateScaleSize="scaleSize = $event"
            @imgMoved="imageMoved" @imgLoaded="imageLoaded" @mouseMove="mouseMove"
            width="100%"
            v-else
          />
        </div>
      </div>
      </v-row>
      <Dialog search :open="searching" :cancel="cancelSearch" title="位置指定道路検索中" />
      <Dialog message :open="canceled" :ok="()=>{canceled=false;$router.back()}"
        title="位置指定道路検索" body="キャンセルされました" />
			<Dialog error :open="notfound" :ok="back"
        title="位置指定道路"
        body="位置指定道路図データがありません。"/>
      <Dialog message :open="confirmPrint" :ok="printOk" :cancel="printCancel"
        title="印刷確認" :body="confirmMessage"/>
      <Dialog message :open="msgDlg" :ok="()=>{msgDlg=false;}"
        :title="dialogTitle" :body="dialogMessage"/>
    </v-container>
  </section>
</template>

<script>
import ImageViewer from '../components/ImageViewer.vue';
import ZoomImageViewer from '../components/ZoomImageViewer.vue'
import ImageCanvas from '../components/ImageCanvas.vue';
import ZoomCanvas from '../components/ZoomCanvas.vue';
import { loadShitei } from '../common/apiAccess';
import { dbglog } from '../common/utils';
import Dialog from '../components/Dialog.vue'

export default {
  components: {
    ImageViewer,
    ZoomImageViewer,
    ImageCanvas,
    ZoomCanvas,
		Dialog,
  },
  data() {
    return {
      useCanvas: true,
      pages: [],
      pageNo: 0,
      scaleSize: 1,
      searching: false,
      canceled: false,
      notfound: false,
      confirmPrint: false,
      confirmMessage: '',
      msgDlg: false,
      dialogTitle: '印刷',
      dialogMessage: '',
      controller: null,
      image: null,    // オリジナル画像オブジェクト
      imageWidth: 0,  // オリジナル画像の幅
      imageHeight: 0, // オリジナル画像の高さ
      imgX: 0,        // ImageViewerのimg要素左位置
      imgY: 0,        // ImageViewerのimg要素上位置
      cursorX: 0,     // ImageViewer画像上のマウスカーソルX座標
      cursorY: 0,     // ImageViewer画像上のマウスカーソYX座標
      viewerRatio: 1, // 部分拡大窓の拡大率
      zoomScale: 1,   // ZoomImageViewerに渡すスケール値
      zoomCenterX: 0, // ZoomImageViewerに渡す画像中心X座標
      zoomCenterY: 0, // ZoomImageViewerに渡す画像中心Y座標
      imageScale: 1,  // ImageCanvasに渡す画像拡大率（画面横幅いっぱいを1とする）
      minScale: 0.666667,
      frameVisible: false, // A3印刷枠表示
      frameX: 0,
      frameY: 0,
      frameInfo: null,
      splitVisible: false,
      splitInfo: null,
    }
  },
  props: {
    id: {
      type: Number,
      default: 0,
    },
    zoomRatio: {
      type: Number,
      default: 2,
    },
    zoomOnMove: {
      type: Boolean,
      default: false,
    },
    splitPrintEnable: {
      type: Boolean,
      default: true,
    }
  },
  watch: {
    scaleSize: {
      immediate: true,
      handler(value) {
        this.zoomScale = value * this.viewerRatio * this.zoomRatio;
        this.zoomCenterX = this.cursorX;
        this.zoomCenterY = this.cursorY;
      }
    },
    imageScale: {
      immediate: true,
      handler(value) {
        this.zoomScale = value * this.viewerRatio * this.zoomRatio;
      }
    },
  },
  mounted () {
    if (this.unauthorized) {
      this.message = 'ユーザー認証されていません。';
      this.$router.replace('/');
    }

    const imgviewer = document.getElementById('image-viewer');
    const zoomimg = document.getElementById('zoom-area');
    this.viewerRatio = imgviewer.offsetWidth / zoomimg.offsetWidth;
    if (this.useCanvas) {
      this.zoomScale = this.imageScale * this.viewerRatio * this.zoomRatio;
    }
    else {
      this.zoomScale = this.scaleSize * this.viewerRatio * this.zoomRatio;
    }

    if (this.id !== undefined && this.id != '') {
      this.$store.commit('setGaiyoId', this.id);
    }
    else {
      this.frameInfo = this.$store.state.frameInfo;
      this.frameVisible = this.frameInfo.visible;
      this.frameX = this.frameInfo.x;
      this.frameY = this.frameInfo.y;
    }
    this.searching = true;
    this.controller = loadShitei(this.$store.state.gaiyoId, (data) => {
      this.searching = false;
      if (data !== null && data.images !== undefined) {
        dbglog(`BrowseSpRoad.mounted: ${data.images.length}`);
        this.message = `位置指定番号 : ${data.shiteiNo}`;
        if (data.images.length == 0) {
          this.notfound = true;
          this.pages = [];
        }
        else {
          this.pages = data.images;
        }
      }
    });
  },
  computed: {
    token () {
      return this.$store.state.token;
    },
    unauthorized () {
      return this.token === undefined || this.token === null
          || this.token.length === undefined || this.token.length == 0;
    },
    authorized () {
      return !this.unauthorized;
    },
    imageUrl () {
      if (this.pages === null || this.pages.length === undefined || this.pages.length == 0 || this.pageNo < 0) {
        return '';
      }
      else {
        const page = this.pages[this.pageNo];
        return page.url;
      }
    },
    scaleSizeReset() {
      return this.scaleSize;
    },
    targetViewId() {
      return this.useCanvas ? 'canvas' : 'img';
    },
    message: {
      get() { return this.$store.state.message; },
      set(val) { this.$store.commit('setMessage', val) }
    },
  },
  methods: {
    showPage (no) {
      this.pageNo = no;
      this.scaleSize = 1;
    },
    zoomIn () {
      if(this.scaleSize < 10){
        this.scaleSize += 1;
      }
      this.imageScale *= 1.5;
    },
    zoomOut () {
      if(this.scaleSize > 1){
        this.scaleSize -= 1;
      }
      if (this.imageScale > 1) {
        this.imageScale = Math.max(1, this.imageScale / 1.5);
      }
    },
    toggleFrameVisible() {
      this.frameVisible = !this.frameVisible;
    },
    printOk () {
      this.confirmPrint = false;
      this.$store.commit('setFrameInfo', {
        visible: this.frameVisible,
        x: this.frameX,
        y: this.frameY,
      });
      if (this.frameVisible) {
        const images = [{
          image: this.image,
          zoom: 1,
          centerx: this.frameX,
          centery: this.frameY,
        }];
        this.$router.push({name:'print-image',
          params:{useCanvas:true, images:images, paper:'A3R'}});
      }
      else if (this.splitVisible) {
        const images = [];
        for (let i = 0; i < this.splitInfo.length; i++) {
          images.push({
            image: this.image,
            zoom: 1,
            centerx: this.splitInfo[i].x,
            centery: this.splitInfo[i].y,
          });
        }
        this.$router.push({name:'print-image',
          params:{useCanvas:true, images:images, paper:'A3R'}});
      }
      else {
        const images = [ this.imageUrl ];
        this.$router.push({name:'print-image',
          //params:{useCanvas:false, images:images, paper:'A3R'}});
          params:{useCanvas:false, images:images, paper:'A3R',
            imageWidth:this.imageWidth, imageHeight:this.imageHeight}});
      }
    },
    printCancel () {
      this.confirmPrint = false;
    },
    printShitei () {
      this.frameVisible = false;
      this.splitVisible = false;
      this.confirmMessage = '位置指定道路図をA3用紙に縮小印刷します。';
      this.confirmPrint = true;
    },
    printSplit() {
      if (this.splitVisible) {
        this.confirmMessage = `位置指定道路図を複数用紙に分割印刷します`;
        this.confirmPrint = true;
      }
      else {
        this.frameVisible = false;
        this.splitVisible = true;
        this.dialogTitle = '選択印刷';
        this.dialogMessage = '水色の分割印刷枠をタッチして印刷したい範囲に移動して下さい。'
          + '\n個々の印刷枠内でダブルクリックすると印刷対象を切り替えられます。';
        this.msgDlg = true;
      }
    },
    printFrame() {
      if (this.frameVisible) {
        this.confirmMessage = '表示枠内をA3用紙に原寸印刷します。';
        this.confirmPrint = true;
      }
      else {
        this.frameVisible = true;
        this.splitVisible = false;
        this.dialogTitle = '選択印刷';
        this.dialogMessage = 'オレンジ色の印刷枠をタッチして印刷したい範囲に移動して下さい。';
        this.msgDlg = true;
      }
    },
    cancelSearch() {
      this.controller.abort();
      this.searching = false;
      this.canceled = true;
    },
    back() {
      this.$router.back();
    },
    imageLoaded(param) {
      if (param) {
        if (this.useCanvas) {
          this.image = param;
          this.imageWidth = param.width;
          this.imageHeight = param.height;
          this.imageScale = 1;
        }
        else {
          this.imageWidth = param.srcw;
          this.imageHeight = param.srch;
        }
      }
    },
    imageMoved(param) {
      this.imgX = param.x;
      this.imgY = param.y;
    },
    imageScaleChanged(scale) {
      this.imageScale = scale;
    },
    frameMoved(param) {
      this.frameX = param.x;
      this.frameY = param.y;
    },
    splitUpdated(param) {
      this.splitInfo = param;
    },
    mouseMove(param) {
      this.cursorX = param.x;
      this.cursorY = param.y;
      if (this.zoomOnMove) {
        this.zoomCenterX = param.x;
        this.zoomCenterY = param.y;
      }
    },
    onImageClick(x, y) {
      if (this.useCanvas) {
        this.zoomCenterX = x;
        this.zoomCenterY = y;
      }
      else {
        this.zoomCenterX = x;
        this.zoomCenterY = y;
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.split {
  position: absolute;
  width: 100%;
  height: calc(100% - 4px);
  padding: 0.0em;
  margin: 0;
}
.left-box {
  left: 0;
  width: 320px;
  height: calc(100% - 16px);
  padding: /*0.3em;*/2px 2px 1px 5px;
  overflow-y: auto;
}
.right-box {
  right: 0;
  width: calc(100% - 320px);
  height: calc(100% - 16px);
  padding: 0;
  overflow: hidden;
  background-color: rgb(198, 226, 225);
}
.active {
  background-color: aquamarine;
}
#zoom-area {
  width: 300px !important;
  height: 200px !important;
  background-color: white;
	overflow: hidden;
}
@media print {
  .left-box {
    visibility: hidden;
    width: 0%;
  }
  .right-box {
    width: 100%;
    overflow-y: auto;
  }
}

</style>